<template>
  <div class="admin-inout-container">
    <el-row :gutter="20">
      <el-col :span="4">
        <select-admin-community @changeCommunity="handleCommunityChange" />
      </el-col>
      <el-col :span="20">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>{{ $t('adminInout.search.title') }}</span>
          </div>
          <el-row :gutter="20">
            <el-col :span="5">
              <el-select
                v-model="conditions.machineId"
                :placeholder="$t('adminInout.search.selectAccessControl')"
                clearable
                class="w-100"
              >
                <el-option
                  v-for="item in accessControls"
                  :key="item.machineId"
                  :label="item.machineName"
                  :value="item.machineId"
                />
              </el-select>
            </el-col>
            <el-col :span="4">
              <el-input
                v-model="conditions.name"
                :placeholder="$t('adminInout.search.inputUserName')"
                clearable
              />
            </el-col>
            <el-col :span="4">
              <el-input
                v-model="conditions.memberId"
                :placeholder="$t('adminInout.search.inputMemberId')"
                clearable
              />
            </el-col>
            <el-col :span="4">
              <el-select
                v-model="conditions.openTypeCd"
                :placeholder="$t('adminInout.search.selectOpenType')"
                clearable
                class="w-100"
              >
                <el-option :label="$t('adminInout.faceOpen')" value="1000" />
                <el-option :label="$t('adminInout.remoteOpen')" value="5000" />
              </el-select>
            </el-col>
            <el-col :span="3">
              <el-button type="primary" @click="handleQuery">
                {{ $t('common.search') }}
              </el-button>
            </el-col>
          </el-row>
          <el-row :gutter="20" class="mt-20">
            <el-col :span="5">
              <el-date-picker
                v-model="conditions.queryStartTime"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                :placeholder="$t('adminInout.search.inputStartTime')"
                class="w-100"
              />
            </el-col>
            <el-col :span="5">
              <el-date-picker
                v-model="conditions.queryEndTime"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                :placeholder="$t('adminInout.search.inputEndTime')"
                class="w-100"
              />
            </el-col>
          </el-row>
        </el-card>

        <el-card class="box-card mt-20">
          <div slot="header" class="clearfix">
            <span>{{ $t('adminInout.list.title') }}</span>
          </div>
          <el-table v-loading="loading" :data="adminInouts" border style="width: 100%">
            <el-table-column
              prop="communityName"
              :label="$t('adminInout.table.communityName')"
              align="center"
            />
            <el-table-column
              prop="machineName"
              :label="$t('adminInout.table.deviceName')"
              align="center"
            />
            <el-table-column
              prop="memberId"
              :label="$t('adminInout.table.memberId')"
              align="center"
            />
            <el-table-column
              prop="name"
              :label="$t('adminInout.table.userName')"
              align="center"
            />
            <el-table-column :label="$t('adminInout.table.openType')" align="center">
              <template slot-scope="scope">
                {{ getOpenTypeName(scope.row.openTypeCd) }}
              </template>
            </el-table-column>
            <el-table-column :label="$t('adminInout.table.openStatus')" align="center">
              <template>
                {{ $t('adminInout.openSuccess') }}
              </template>
            </el-table-column>
            <el-table-column :label="$t('adminInout.table.openTime')" align="center">
              <template slot-scope="scope">
                {{ scope.row.fileTime || scope.row.createTime }}
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            class="mt-20"
            :current-page.sync="page.current"
            :page-sizes="[10, 20, 30, 50]"
            :page-size="page.size"
            :total="page.total"
            layout="total, sizes, prev, pager, next, jumper"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import SelectAdminCommunity from '@/components/community/selectAdminCommunity'
import { listAdminAccessControlInout, listAdminAccessControl } from '@/api/iot/adminInoutApi'

export default {
  name: 'AdminInoutList',
  components: {
    SelectAdminCommunity
  },
  data() {
    return {
      loading: false,
      adminInouts: [],
      accessControls: [],
      conditions: {
        machineId: '',
        name: '',
        memberId: '',
        openTypeCd: '',
        queryStartTime: '',
        queryEndTime: '',
        communityId: '',
        page: 1,
        row: 10
      },
      page: {
        current: 1,
        size: 10,
        total: 0
      }
    }
  },
  created() {
    this.listAccessControls()
    this.listAdminInouts()
  },
  methods: {
    async listAdminInouts() {
      try {
        this.loading = true
        const res = await listAdminAccessControlInout(this.conditions)
        this.adminInouts = res.data || []
        this.page.total = res.total || 0
      } catch (error) {
        this.adminInouts = []
        this.page.total = 0
        this.$message.error(error.message || this.$t('adminInout.fetchRecordsError'))
      } finally {
        this.loading = false
      }
    },
    async listAccessControls() {
      try {
        const params = {
          page: 1,
          row: 100,
          communityId: this.conditions.communityId
        }
        const res = await listAdminAccessControl(params)
        this.accessControls = res.data || []
      } catch (error) {
        this.accessControls = []
        this.$message.error(error.message || this.$t('adminInout.fetchDevicesError'))
      }
    },
    handleCommunityChange(community) {
      this.conditions.communityId = community.communityId
      this.conditions.machineId = ''
      this.conditions.page = 1
      this.page.current = 1
      this.listAccessControls()
      this.listAdminInouts()
    },
    handleQuery() {
      this.conditions.page = 1
      this.page.current = 1
      this.listAdminInouts()
    },
    handleSizeChange(size) {
      this.page.size = size
      this.conditions.row = size
      this.conditions.page = 1
      this.page.current = 1
      this.listAdminInouts()
    },
    handleCurrentChange(current) {
      this.conditions.page = current
      this.listAdminInouts()
    },
    getOpenTypeName(openTypeCd) {
      if (openTypeCd === '1000') {
        return this.$t('adminInout.faceOpen')
      }
      if (openTypeCd === '5000') {
        return this.$t('adminInout.remoteOpen')
      }
      return '-'
    }
  }
}
</script>

<style scoped>
.admin-inout-container {
  padding: 20px;
}

.mt-20 {
  margin-top: 20px;
}

.w-100 {
  width: 100%;
}
</style>
